/* eslint-disable sort-keys */
export const STATUS_PAGINA_NAO_ENCONTRADA = 404
export const TITULO_APOIO_PAGINA_NAO_ENCONTRADA = 'Ops, algo deu errado!'
export const DESCRICAO_PAGINA_NAO_ENCONTRADA = 'Infelizmente, não encontramos a página que você procura. Veja abaixos alguns links que podem ser úteis:'
export const LINKS_PAGINA_NAO_ENCONTRADA_ASSOCIADO_LOGADO = {
  'curadoria': {
    'nome': 'Curadoria',
    'slug': '/curadoria'
  },
  'ineditos': {
    'nome': 'Inéditos',
    'slug': '/inéditos'
  },
  'home': {
    'nome': 'Home',
    'slug': '/'
  },
  'perfil': {
    'nome': 'Perfil',
    'slug': '/perfil'
  }
}

export const LINKS_PAGINA_NAO_ENCONTRADA_ASSOCIADO_NAO_LOGADO = {
  'login': {
    'nome': 'Login',
    'slug': '/login'
  }
}
